import { SessionDeprecatedService } from '@commons/core/auth/session-deprecated.service';
import { IComponentController } from 'angular';

export class PermissionCtrl implements IComponentController {
  constructor(private readonly sessionDeprecatedService: SessionDeprecatedService) {}

  $onInit() {}

  hasPermission(permission: string): boolean {
    return this.sessionDeprecatedService.hasPermission(permission);
  }

  lacksPermission(permission: string): boolean {
    return !this.sessionDeprecatedService.hasPermission(permission);
  }

  hasRole(): boolean {
    const roles: any[] = [];
    for (let i = 0; i < arguments.length; i++) {
      roles.push(arguments[i]);
    }
    return this.sessionDeprecatedService.hasRoles(roles);
  }
}
